import { UseFormReturnType } from "@mantine/form"
import { ImageFieldValue } from "./pageGroupPayload"

/** テンプレート編集モーダルが扱うページの種別 */
export type TemplatePageType = 'common' | 'inviter' | 'guest'

/** アップロード画像の種類 */
export type ImageKind = 'KEY_VISUAL' | 'LOGO' | 'INCENTIVE_IMAGE' | 'INCENTIVE_IMAGE_GUEST'

/** アップロード直後の画像。preview は解放が必要なので File と組で保持する */
export interface UploadedImage {
  file: File
  preview: string
}

export type UploadedImages = Record<ImageKind, UploadedImage | null>

export interface TemplatePageFormValues {
  // page_group 由来
  pageDescription: string
  enabled: string
  bodyHtml: string
  startDate: string
  endDate: string
  enable_web_cv: boolean
  enable_coming_cv: boolean
  key_visual: ImageFieldValue
  key_visual_text: string
  link_text: string
  link_url: string
  flow_text: string
  notice: string
  terms: string
  privacy_policy: string
  tag: string
  template_type: number
  logo: ImageFieldValue
  incentive_action: string
  incentive_content: string
  incentive_amount: string
  incentive_image: ImageFieldValue
  incentive_content_guest: string
  incentive_amount_guest: string
  incentive_image_guest: ImageFieldValue
  theme_color: string
  button_color: string
  guest_limit: number | string

  // client 由来
  line_message: string
  target_cv_num: number | string
  coming_name: boolean
  coming_mail: boolean
  coming_tel: boolean
  coming_other: boolean
  coming_address: boolean
}

/**
 * template_type からテンプレートのディレクトリ名を引く。
 * invite ページには template_type, guest ページには template_type + 1 が割り当てられる
 * （page_groups_controller#sync_common_to_invite_guest）ため、奇数と次の偶数が同じテンプレートを指す
 */
const TEMPLATE_DIR_BY_TYPE: Record<number, string> = {
  1: 'tpl-original-new',
  2: 'tpl-original-new',
  3: 'tpl-simple-cool-new',
  4: 'tpl-simple-cool-new',
  5: 'tpl-cute-pop-new',
  6: 'tpl-cute-pop-new',
}

/** テンプレート別デフォルト画像のURL。template_type が未設定・未知なら空文字 */
export const templateImageUrl = (templateType: number, fileName: string): string => {
  const dir = TEMPLATE_DIR_BY_TYPE[templateType]
  return dir ? `/app_templates/${dir}/${fileName}` : ''
}

/** エディタ3種に共通で渡す props */
export interface TemplateEditorProps {
  form: UseFormReturnType<TemplatePageFormValues>
  images: UploadedImages
  onUploadImage: (kind: ImageKind, files: File[]) => void
  onClearImage: (kind: ImageKind) => void
}
